import {createAction, props} from '@ngrx/store';
import {Mode} from './settings.model';

export const setMode = createAction('[Settings] Mode', props<{ mode: Mode }>());
export const selectCharacter = createAction('[Settings] Select Character', props<{ id: string }>());
export const deselectCharacter = createAction('[Settings] Deselect Character');
